import { withStyles } from '@material-ui/core/styles';
import GridListTile from '@material-ui/core/GridListTile';

export default withStyles(() => ({
  root: {
    height: '100px',
  },
}))(GridListTile);
